/* eslint max-classes-per-file: 0 */

import {
  Formdata as Data,
  FormdataCollection as Collection,
} from '@/typings/api/Formdata'
import { FormdataApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'

const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class FormDataTransformerParams extends TransformerParams {
}

export class FormDataAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new FormDataTransformerParams();
}
